<div class="container">
    <div class="row">
        <div class="col mt-5">
            <h1>Seja muito bem-vindo ao futuro dos seus estudos!</h1>
            <p>Assim que o seu pagamento for processado, você receberá um e-mail de confirmação da Hotmart e, logo em
                seguida, um e-mail do Estudei com o passo a passo para fazer seu primeiro login na plataforma.</p>
            <p>Assista ao tutorial passo a passo do Estudei: <a
                    href="https://estudei.com.br/tutorial">estudei.com.br/tutorial</a>.</p>
            <p>Se você tiver qualquer problema ou dificuldade, é só chamar a gente em <a
                    href="mailto:contato@estudei.com.br">contato&#64;estudei.com.br</a>.</p>
            <p>Bons estudos!</p>

            <div class="card mt-5">
                <div class="card-body">
                    <iframe
                        src="https://www.youtube.com/embed/wY09KueSxis?autoplay=0&controls=1&loop=0&playlist=wY09KueSxis&rel=0"
                        title="[Revelação!] Vem aí... a evolução dos seus estudos" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen></iframe>
                </div>
            </div>
        </div>
    </div>
</div>